/*DIVISION BRIEFS*/
Vue.component('divisionbriefs', {
    template:'#divisionbriefs-template',
    data:function(){
        return{
            list: [],
            searchString:'',
            modal:'',
            editing_id: null,
            brief_list: null,
            editing_row: {
                field: null,
                required: false,
                original_data: {}
            },
            creating_assignment: {
                type: 'project',
                required: false,
                division: {}
            },
            create_division_id: null,
            create_field: null
        };
    },
    created:function(){
        activeInstance = this;
        activeInstance.modal = $('body').find('#create_user_modal').html();

        showLoadingOverlay();
        Vue.http.get(baseURL+'/api/division_briefs',function(response){
            $('body').LoadingOverlay("hide");
            activeInstance.list=response;

            setTimeout(function(){
                var $table = $('.fixed_header_table');
                $table.floatThead({
                    top:65
                });
            },200);
        }).bind(this);
    },
    watch: {
        editing_id: function(val) {
            if (val == null) {
                this.editing_row.field = null;
                this.editing_row.required = false;

                return;
            }

            this.editing_row.required = this.editing_row.field.validation_rules.indexOf('required')!=-1;
        },
        create_division_id: function(val) {
            if (val == null) {
                this.create_field = null;

                return;
            }
        }
    },
    methods:{
        cancelEditing: function() {
            if (this.editing_id == null) {
                return;
            }

            this.editing_row.field.enabled = this.editing_row.original_data.enabled;
            this.editing_row.field.validation_rules = this.editing_row.original_data.validation_rules;
            this.editing_row.field.type = this.editing_row.original_data.type;
            
            this.editing_id = null;
        },
        edit: function(brief_template) {
            this.cancelEditing();
            this.editing_row.original_data = JSON.parse(JSON.stringify(brief_template));
            this.editing_row.field = brief_template;
            this.editing_id = brief_template.id;
        },
        save: function() {
            var validation_rules = (activeInstance.editing_row.required) ? 'required' : '';

            axios.post(baseURL + '/ajax/brief_division_assignments/update', {
                id: activeInstance.editing_row.field.id,
                enabled: activeInstance.editing_row.field.enabled,
                validation_rules: validation_rules,
                type: activeInstance.editing_row.field.type
            }).then(function(response) {

                activeInstance.editing_row.field.validation_rules = validation_rules;
                activeInstance.editing_id = null;

            }).catch(function(error) {
                console.log(error);
            });
        },
        createOpen: function(division) {
            if (this.brief_list == null) {
                showLoadingOverlay();
                axios.get(baseURL + '/ajax/brief/list').then(function(response) {
                    $('body').LoadingOverlay("hide");
                    activeInstance.brief_list = response.data;
                });
            }

            this.creating_assignment.division = division;
            this.create_division_fields = division.brief_template;
            this.create_division_id = division.id;
        },
        saveAssignment: function(index) {
            var validation_rules = (activeInstance.creating_assignment.required) ? 'required' : ''; 

            axios.post(baseURL + '/ajax/brief_division_assignments/create', {
                brief_field_id: activeInstance.create_field,
                division_id: activeInstance.create_division_id,
                validation_rules: validation_rules,
                type: activeInstance.creating_assignment.type
            }).then(function(response) {

                console.log(index);
                $('html, body').animate({
                    scrollTop: $("#division_"+index).offset().top -90
                }, 600);

                activeInstance.creating_assignment.division.brief_template.push(response.data);
                activeInstance.create_division_id = null;
            }).catch(function(error) {
                console.log(error);
            });
        },
        filterByAssignedField: function(arr) {
            if (arr == null) {
                return [];
            }

            arr = arr.filter(function(val) {
                var assigned = false;
                for(var i = 0, i_l = activeInstance.creating_assignment.division.brief_template.length; i < i_l; i ++) {
                    if (activeInstance.creating_assignment.division.brief_template[i].brief_field_id == val.id) {
                        assigned = true;
                        break;
                    }
                }
                return !assigned;
            });
            return arr;
        }
    }
});
